import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'app/_helpers/base/base.service';

@Injectable({
  providedIn: 'root'
})
export class AccessTokensService {

  private readonly modelUrl = 'access_tokens';

  constructor(
    private _baseService: BaseService
  ) { }

  getAll(): Observable<any> {
    return this._baseService.get(`${this.modelUrl}/all`, 'nodejs');
  }

  create(data: any): Observable<any> {
    return this._baseService.post(`${this.modelUrl}/create`, data, 'nodejs');
  }

  revoke(id: string): Observable<any> {
    return this._baseService.put(`${this.modelUrl}/revoke/${id}`, null, 'nodejs');
  }

  regenerate(id: string): Observable<any> {
    return this._baseService.post(`${this.modelUrl}/regenerate/${id}`, {}, 'nodejs');
  }

  update(id: string, data: any): Observable<any> {
    return this._baseService.put(`${this.modelUrl}/update/${id}`, data, 'nodejs');
  }
}
